import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { NetworkManager } from './NetworkManager';
import ToastManager from './ToastManager';
import CreatableSelect from "react-select/creatable";

const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

interface EmailOption {
  label: string;
  value: string;
}

interface MultiEmailInputProps {
  value: EmailOption[];
  loadedData: any
  selectedImages: string[],
  isDisabled?: boolean;
  placeholder?: string;
  onClose: () => void;
}

const MultiEmailInput: React.FC<MultiEmailInputProps> = ({
  value = [],
  loadedData,
  selectedImages,
  isDisabled = false,
  placeholder = 'Enter Email Id',
  onClose,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [inputError, setInputError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

   
  const onLoginError = (err: any) => {
    console.log(err);
  };

  const formik = useFormik({
    initialValues: {
      email: value,
    },
    validationSchema: Yup.object({
      email: Yup.array()
        .of(
          Yup.object({
            value: Yup.string()
              .required('Email is required')
              .test('valid-email', 'Invalid email', (val) => isValidEmail(val || '')),
            label: Yup.string(),
          })
        )
        .min(1, 'Please add at least one valid email'),
    }),
    onSubmit: (values) => {
      const emails = values.email.map((e) => e.value);
      handleShare(emails);
    },
  });

  
  const handleShare = (validEmails: string[]) => {
    setIsLoading(true);
    const imgPaths = selectedImages.map((img: any) => ({
        imaeFilePath: img,
      }));

    const payload = {
        orgId: loadedData?.[0]?.saasOrgId,
        docId: loadedData?.[0]?.documentId,
        vinNumber: loadedData?.[0]?.vinNumber,
        brand: loadedData?.[0]?.brand,
        unitNumber: loadedData?.[0]?.unitNumber,
        licenseNumber: loadedData?.[0]?.licenseNumber,
        isToShare: true,
        receipientEmails: validEmails,
        images: imgPaths,
      }
    const url = "api/v2/tiny-url/create"
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onShareSuccess, onLoginError);
  };

  const onShareSuccess = (dataObj: any) => {
    if (typeof dataObj === 'string' && dataObj.includes('requestor') && dataObj.includes('id')) {
      setIsLoading(false);
      onClose();
      ToastManager.showToast(`${selectedImages?.length} Images Shared Successfully`, "Info");
    } else {
      ToastManager.showToast("Unexpected response format", "Error");
    }
  };


  const handleCreate = (input: string) => {
    if (isValidEmail(input)) {
      const newOption = { label: input, value: input };
      const updated = [...formik.values.email, newOption];
      formik.setFieldValue('email', updated);
      setInputError(null);
    } else {
      setInputError('Invalid email format');
    }
    setInputValue('');
  };

  const handleChange = (selected: any) => {
    formik.setFieldValue('email', selected);
    setInputError(null);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='mb-3' style={{height: "70px"}}>
        {/* <span className='ms-2 mb-1'>{selectedImages.length} images selected</span> */}
        <CreatableSelect
          className="form-select"
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null, 
            ClearIndicator: () => null, 
            Menu: () => null,
          }}
          styles={{
            control: (provided: any) => ({
              ...provided,
              minHeight: "80px",
              maxHeight: "100px",
              overflowY: "scroll",
              position: "absolute",
              width: "101%",
              top: "-1px",
              backgroundColor: "#ffffff",
              left: "-1px",
            }),
            valueContainer: (provided) => ({
              ...provided,
              paddingRight: '8px'
            }),
          }}
          isMulti
          name="email"
          isDisabled={isDisabled}
          inputValue={inputValue}
          onInputChange={(val: any) => setInputValue(val)}
          onChange={handleChange}
          onCreateOption={handleCreate}
          value={formik.values.email}
          options={[]}
          placeholder={placeholder}
          onBlur={() => formik.setFieldTouched('email', true)}
        />
      </div>
        {(formik.touched.email && formik.errors.email) ? (
          <small className="ms-2 text-danger fw-700">{typeof formik.errors.email === 'string' && formik.errors.email}</small>) : (
            <small className="ms-2 fst-italic fw-700">{`Enter your email ID and press the Enter key on the keyboard.`}</small>
          )
        }
        {inputError && (
          <small className="ms-2 text-danger fw-700">{inputError}</small>
        )}
      <div className="modal-footer">
        <button type="button" className="btn btn-outline-light ms-1" onClick={onClose}>Close</button>
        <button type="submit" className="btn-green" disabled={isLoading || !formik.isValid || !formik.dirty}>{isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Sharing Pictures...
              </>
            ) : (
              "Share"
            )}</button>
      </div>
    </form>
  );
};

export default MultiEmailInput;
